import { render, staticRenderFns } from "./TrainCommon.vue?vue&type=template&id=2a25fba4&scoped=true"
import script from "./TrainCommon.vue?vue&type=script&lang=js"
export * from "./TrainCommon.vue?vue&type=script&lang=js"
import style0 from "./TrainCommon.vue?vue&type=style&index=0&id=2a25fba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25fba4",
  null
  
)

export default component.exports